import ReactMarkdown from "react-markdown";
import { Copy, Download, FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { companyLabel, monthLabel, downloadSummary } from "@/lib/aiSummaries";

export const SummaryReport = ({ report, text, busy }) => {
  const copy = async () => {
    try { await navigator.clipboard.writeText(report.content); toast.success("Summary copied"); }
    catch { toast.error("Could not copy. Please use Download instead."); }
  };
  return (
    <section className="ai-report" data-testid="ai-summary-report" aria-busy={busy}>
      <div className="flex items-start justify-between flex-wrap gap-3 mb-6">
        <div>
          <h2 className="font-heading text-base md:text-lg font-semibold" data-testid="ai-report-title">{report ? `${monthLabel(report.month)} summary` : "Monthly briefing"}</h2>
          {report && <p className="text-xs text-stone-500 mt-1" data-testid="ai-report-meta">{companyLabel(report.company)} · {report.model} · {new Date(report.created_at).toLocaleString("en-IN")}</p>}
        </div>
        {report && !busy && <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={copy} title="Copy summary" data-testid="ai-copy-summary"><Copy />Copy</Button>
          <Button variant="outline" size="sm" onClick={() => downloadSummary(report)} title="Download summary and source totals" data-testid="ai-download-summary"><Download />Download</Button>
        </div>}
      </div>
      {text ? <div className="ai-markdown" data-testid="ai-summary-content">
        <ReactMarkdown disallowedElements={["img", "a", "table"]} unwrapDisallowed>{text}</ReactMarkdown>
      </div> : <div className="py-10 text-stone-500 flex flex-col items-center text-center gap-3" data-testid="ai-summary-empty">
        {busy ? <Loader2 className="w-8 h-8 animate-spin text-primary" /> : <FileText className="w-8 h-8 text-stone-400" />}
        <p className="text-sm">{busy ? "Preparing your monthly briefing…" : "No summary generated yet"}</p>
      </div>}
      {busy && text && <p className="text-xs mt-4 text-primary flex items-center gap-2" role="status" data-testid="ai-stream-status"><Loader2 className="w-3 h-3 animate-spin" />Generating…</p>}
      {!!text && <p className="border-t border-stone-200 pt-4 mt-6 text-xs text-stone-500" data-testid="ai-review-notice">AI-generated. Review against source records before making decisions. HR records remain unchanged.</p>}
    </section>
  );
};